import { apiHeaders, apiURL } from '../services/config';

export const load = (phaseId) => ({
  method: 'GET',
  credentials: 'include',
  headers: apiHeaders,
  endpoint: apiURL(`/phases/${phaseId}/rubric`),
});
